import { render, staticRenderFns } from "./editionList.vue?vue&type=template&id=3d6f0d9c&scoped=true"
import script from "./editionList.vue?vue&type=script&lang=js"
export * from "./editionList.vue?vue&type=script&lang=js"
import style0 from "./editionList.vue?vue&type=style&index=0&id=3d6f0d9c&prod&lang=css"
import style1 from "./editionList.vue?vue&type=style&index=1&id=3d6f0d9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6f0d9c",
  null
  
)

export default component.exports